import { useEffect, useRef } from 'react';

export default function useDocumentTitle(title: string, prevailOnUnmount = false) {
  const defaultTitle = useRef(document.title);

  useEffect(() => {
    document.title = title;
  }, [title]);

  useEffect(() => {
    return () => {
      if (!prevailOnUnmount) document.title = defaultTitle.current;
    };
  }, [prevailOnUnmount]);
}
